import { Button, Stack, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import RightDrawer from "components/rightDrawer/RightDrawer";
import DateRangeField from "components/ui/dateRangeField";
import DateTimePicker from "components/ui/dateTimePicker";
import InputField from "components/ui/inputField";
import Select from "components/ui/select";
import { useFormik } from "formik";
import * as yup from "yup";
import getInitialvalues from "../../utils/filterInitialValues";
import { monthsInformat } from "../AddEdit";
import useQueries from "hooks/useQueries";

const AdvanceFilter = ({
  openDrawer,
  setOpenDrawer,
  setReload,
  setFilters,
  filters,
  isFiltering,
  pagination,
  setPagination,
  bankInvoiceStatuses,
  paymentMethods,
}) => {
  const { setQueries } = useQueries();
  const initialValues = getInitialvalues(filters);
  const validationSchema = yup.object({});
  const onSubmit = async (data) => {
    setFilters({ ...filters, ...data });
    setOpenDrawer(false);
    setPagination({ ...pagination, current_page: 1 });
    setReload((pre) => !pre);
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const resetForm = () => {
    const emptyFilter = {};
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        emptyFilter[key] = [];
      } else {
        emptyFilter[key] = null;
      }
    }
    setQueries({}); // Clear queries in URL
    formik.setValues(emptyFilter);
    setFilters({});
    setReload((pre) => !pre);
    setOpenDrawer(false);
  };

  return (
    <RightDrawer
      {...{
        openDrawer,
        setOpenDrawer,
        width: "400px",
        headingLeft: "Advanced Filters",
        headingRight: "",
      }}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Stack
          direction="column"
          gap="15px"
          p="20px"
          sx={{ height: "calc(100vh - 125px)", overflowY: "auto" }}
        >
          <Select
            name="month"
            options={monthsInformat}
            label="Select Months"
            formik={formik}
            selectProps={{ id: "id", label: "name" }}
          />

          <DateTimePicker
            views={["year"]}
            name="year"
            label="Year"
            formik={formik}
          />
          <DateRangeField
            label="Paymnet at"
            from="payment_date_from"
            to="payment_date_to"
            formik={formik}
          />
          <DateRangeField
            label="Created at"
            from="created_at_from"
            to="created_at_to"
            formik={formik}
          />

          <Typography variant="subtitle2" sx={{ mt: 1 }}>
            Paid Amount Range
          </Typography>
          <Stack direction="row" gap={1} alignItems="center">
            <InputField
              name="paid_amount_from"
              label="From"
              formik={formik}
              type="number"
            />
            <ArrowForward sx={{ color: "#999", fontSize: 20 }} />
            <InputField
              name="paid_amount_to"
              label="To"
              formik={formik}
              type="number"
            />
          </Stack>

          <Typography variant="subtitle2" sx={{ mt: 1 }}>
            Due Amount Range
          </Typography>
          <Stack direction="row" gap={1} alignItems="center">
            <InputField
              name="due_amount_from"
              label="From"
              formik={formik}
              type="number"
            />
            <ArrowForward sx={{ color: "#999", fontSize: 20 }} />
            <InputField
              name="due_amount_to"
              label="To"
              formik={formik}
              type="number"
            />
          </Stack>
        </Stack>
        <Stack
          direction="row"
          gap="15px"
          p="10px 20px"
          justifyContent="flex-end"
        >
          {isFiltering() ? (
            <Button variant="outlined" onClick={resetForm}>
              Reset Filter
            </Button>
          ) : (
            <Button variant="outlined" onClick={() => setOpenDrawer(false)}>
              Cancel
            </Button>
          )}
          <Button
            variant="solid"
            onClick={formik.submitForm}
            disabled={!formik.dirty}
          >
            Filter Sales
          </Button>
        </Stack>
      </LocalizationProvider>
    </RightDrawer>
  );
};

export default AdvanceFilter;
